import { ShortcodeFn } from 'components/vendor/Contentful/richText/ShortcodeManager'
import { sanitizeUrl } from '../utils'
import { LinkButton } from 'ui/inputs/Button/LinkButton'

export const buttonShortcode: ShortcodeFn = (name, attrs) => {
	const linkAttrs = { link: attrs['button'], text: attrs['text'] }
	const safeUrl = sanitizeUrl(linkAttrs.link)
	const localLink = safeUrl.charAt(0) === '/'
	const target = localLink ? '_self' : '_blank'
	const rel = localLink ? '' : 'noreferrer nofollow noopener'
	return (
		<LinkButton href={safeUrl} target={target} rel={rel} style={{ color: '#fff' }}>
			{linkAttrs.text}
		</LinkButton>
	)
}
